export default "__VITE_ASSET__BPODsIYg__"